<div class="main">
    <!-- メインコンテンツ -->
    <div class="main-content">
      <div class="contact p-col-12 card pb-3">
        <div class="p-col-12 head">ウェブアクセシビリティ</div>
        <p-divider type="solid"></p-divider>
        <div class="p-col-12 p-pt-3 p-pb-3">ウェブアクセシビリティとは「高齢者や障がい者を含めて、誰もがホームページで提供される情報や機能を支障なく利用することができる」ことです。 コドモミライコネクト（以下「本サイト」という。）では日本産業規格JIS X 8341-3：2016（高齢者・障害者等配慮設計指針-情報通信における機器、ソフトウェア及びサービス－第3部：ウェブコンテンツ）に配慮したウェブページ作成に取り組んでおります。 このページではホームページのウェブアクセシビリティへの対応とJIS X 8341-3：2016に基づく試験結果について掲載しています。</div>
        <div class="page-title">
					<label class="name">達成した等級
					</label>
			  </div>
        <div class="p-col-12 p-pt-3 p-pb-3">ウェブコンテンツのアクセシビリティ達成等級AA　準拠<br>
 <br>
なお、「準拠」という対応度の表記は、情報通信アクセス協議会ウェブアクセシビリティ基盤委員会「<a href="https://waic.jp/docs/jis2016/compliance-guidelines/202104/" target="_blank"><ins>ウェブコンテンツのJIS X 8341-3:2016 対応度表記ガイドライン</ins></a>」で定められた表記によるものです。</div>
        <div class="page-title">
					<label class="name">対象範囲
					</label>
			  </div>
        <div class="p-col-12 p-pt-3 p-pb-3">
          <span>福岡県中高生と乳幼児のふれあい体験マッチングシステム「コドモミライコネクト」<br></span>
          <a href="https://kodomo-fureai.pref.fukuoka.lg.jp/" class="linktext-blue underline">https://kodomo-fureai.pref.fukuoka.lg.jp/</a>
        </div>
        <div class="page-title">
					<label class="name">例外事項
					</label>
			  </div>
        <div class="p-col-12 p-pt-3 p-pb-3">
          <span>PDF等添付ファイル、別ドメインの外部サーバから情報提供されるコンテンツ（Googleマップ、Googleカスタム検索、YouTube、Instagram等）、外部サイトへのバナー広告画像、一般ユーザーから投稿されるコンテンツ<br>
          </span>
        </div>
        <div class="page-title">
					<label class="name">試験を行ったページのURLリスト
					</label>
			  </div>
        <div class="p-col-12 p-pt-3 p-pb-3 wrap">
          <ul>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/login</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/a110</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/a201</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/a203</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/a204</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/a210</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/a211</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/a212</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/a213</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/a231/配下</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/accessibility</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/b101/配下</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/b211/配下</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/b220</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/b221</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/b223</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/b301</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/c231</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/c241</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/c261</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/c331/配下</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/c341/配下</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/c361/配下</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/c401</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/c461/配下</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/c502</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/c601/配下</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/c602/配下</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/contact</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/e001/配下</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/e002/配下</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/master/m101</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/master/m201</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/master/m301</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/master/m401</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/master/m501</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/master/m601</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/master/m701</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/privacy</li>
            <li>&#9679; https://kodomo-fureai.pref.fukuoka.lg.jp/pages/platform/secretariat-list/d211</li>
          </ul>
        </div>
        <div class="page-title">
					<label class="name">依存したウェブコンテンツ技術
					</label>
			  </div>
        <div class="p-col-12 p-pt-3 p-pb-3">
          HTML5、CSS3、JavaScript
        </div>
        <div class="page-title">
					<label class="name">試験実施期間
					</label>
			  </div>
        <div class="p-col-12 p-pt-3 p-pb-3">
          2025年11月1日～2025年11月15日
        </div>
        <div class="page-title">
					<label class="name">達成基準チェックリスト
					</label>
			  </div>
        
        <div class="container">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>細分箇所</th>
                <th>達成基準</th>
                <th>適合<br>レベル</th>
                <th>適用</th>
                <th>結果</th>
                <th>備考</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of tableData; let i = index">
                <th>{{ row.subdivision }}</th>
                <td class="text-left">{{ row.criteria }}</td>
                <td>{{ row.level }}</td>
                <td>{{ row.application }}</td>
                <td>{{ row.result }}</td>
                <td class="text-left">{{ row.remarks }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <app-landing-footer></app-landing-footer>
</div>
